import { render, staticRenderFns } from "./PageBillings.vue?vue&type=template&id=174a6130&"
import script from "./PageBillings.vue?vue&type=script&lang=js&"
export * from "./PageBillings.vue?vue&type=script&lang=js&"
import style0 from "./PageBillings.vue?vue&type=style&index=0&id=174a6130&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports